import angular from 'angular';
import modalDelegationManagerComponent from './modalDelegationManager.component';
import modalCreateDelegation from './modalCreateDelegation/modalCreateDelegation';
import modalEditDelegation from './modalEditDelegation/modalEditDelegation';
import modalCancelDelegation from './modalCancelDelegation/modalCancelDelegation';

let modalDelegationManagerModule = angular.module('modalDelegationManager', [
  modalCreateDelegation,
  modalCancelDelegation,
  modalEditDelegation,
])

.component('modalDelegationManager', modalDelegationManagerComponent)

.name;

export default modalDelegationManagerModule;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalDelegationManager.js